import { useState, useEffect } from 'react';// Adjust the path to match your project structure

export const useMainContentLogic = () => {
  const [data, setData] = useState<any>(); // Initialize state with static data
  const [error, setError] = useState<string | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [darkMode, setDarkMode] = useState<boolean>(false);
  const [currentTaranga, setCurrentTaranga] = useState<any>(0);

  useEffect(() => {
    console.log('useEffect is running');
  
    fetch('/data.json')
      .then((response) => {
        console.log('Fetching JSON data...');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => {
        setData(jsonData);
        console.log('Data fetched:', jsonData);
      })
      .catch((err) => {
        setError('Error fetching JSON data');
        console.error('Fetch error:', err);
      });
  }, []);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  const handleThemeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDarkMode(event.target.checked);
  };

  const handleTarangaNavigation = (index: number) => {
    setCurrentTaranga(index);
  };

  return {
    data,
    error,
    open,
    darkMode,
    currentTaranga,
    handleDrawerToggle,
    handleThemeChange,
    handleTarangaNavigation,
  };
};
